const BAIZE_OPEN_MODAL = 'baize/OPEN_MODAL';
const BAIZE_CLOSE_MODAL = 'baize/CLOSE_MODAL';

// we are initializing to a blank string instead of an actual title,
// because it would be hard to localize here
const initialState = {
  baizeLottie: false,
  baizeRightCount: {count: 0, type: 'underway', reward: []}
};

const reducer = function (state, action) {
    if (typeof state === 'undefined') state = initialState;
    switch (action.type) {
    case BAIZE_OPEN_MODAL:
        return Object.assign({}, state, {
          [action.modal]: true,
          baizeRightCount: action.baizeRightCount
        });
    case BAIZE_CLOSE_MODAL:
        return Object.assign({}, state, {
          [action.modal]: false
        })
    default:
        return state;
    }
};


export {
    reducer as default,
    initialState as baizeInitialState
};
